const state = {};

const getters = {
	// List of countries and their primary currencies
	available_countries(state, getters, rootState, rootGetters) {
		// Filter list of countries by merchant's available currencies
		var countries = getters.countries.filter(
			x => rootGetters.rates.map(y => y.Currency).includes(x.currency)
		);
		// Filter out countries by merchant's allowed countries
		if (
			rootGetters.merchant.CustomerCountries !== undefined &&
			Array.isArray(rootGetters.merchant.CustomerCountries) &&
			rootGetters.merchant.CustomerCountries.length > 0
		) {
			// Filter country list by those allowed by merchant config
			countries = countries.filter(x => rootGetters.merchant.CustomerCountries.includes(x.code));
		}
		return countries;
	},
	country_options(state, getters) {
		const options = getters.available_countries.map(({ code, name }) => ({ id: code, value: name }));
		options.sort((a, b) => a.name > b.name);
		return options;
	},
	currency_options(state, getters) {
		const currencies = new Set(getters.available_countries
			.map(country => country.currency));
		return [...currencies]
			.sort()
			.map(currency => ({ id: currency, value: currency }));
	},
	countries(state) {
		return [
			{
				"code": "AF",
				"name": "Afghanistan",
				"currency": "AFN"
			},
			{
				"code": "AL",
				"name": "Albania",
				"currency": "ALL"
			},
			{
				"code": "DZ",
				"name": "Algeria",
				"currency": "DZD"
			},
			{
				"code": "AS",
				"name": "American Samoa",
				"currency": "USD"
			},
			{
				"code": "AD",
				"name": "Andorra",
				"currency": "EUR"
			},
			{
				"code": "AO",
				"name": "Angola",
				"currency": "AOA"
			},
			{
				"code": "AI",
				"name": "Anguilla",
				"currency": "XCD"
			},
			{
				"code": "AQ",
				"name": "Antarctica",
				"currency": "XCD"
			},
			{
				"code": "AG",
				"name": "Antigua and Barbuda",
				"currency": "XCD"
			},
			{
				"code": "AR",
				"name": "Argentina",
				"currency": "USD"
			},
			{
				"code": "AM",
				"name": "Armenia",
				"currency": "AMD"
			},
			{
				"code": "AW",
				"name": "Aruba",
				"currency": "AWG"
			},
			{
				"code": "AU",
				"name": "Australia",
				"currency": "AUD"
			},
			{
				"code": "AT",
				"name": "Austria",
				"currency": "EUR"
			},
			{
				"code": "AZ",
				"name": "Azerbaijan",
				"currency": "AZN"
			},
			{
				"code": "BS",
				"name": "Bahamas",
				"currency": "BSD"
			},
			{
				"code": "BH",
				"name": "Bahrain",
				"currency": "BHD"
			},
			{
				"code": "BD",
				"name": "Bangladesh",
				"currency": "BDT"
			},
			{
				"code": "BB",
				"name": "Barbados",
				"currency": "BBD"
			},
			{
				"code": "BY",
				"name": "Belarus",
				"currency": "BYR"
			},
			{
				"code": "BE",
				"name": "Belgium",
				"currency": "EUR"
			},
			{
				"code": "BZ",
				"name": "Belize",
				"currency": "BZD"
			},
			{
				"code": "BJ",
				"name": "Benin",
				"currency": "XOF"
			},
			{
				"code": "BM",
				"name": "Bermuda",
				"currency": "BMD"
			},
			{
				"code": "BT",
				"name": "Bhutan",
				"currency": "BTN"
			},
			{
				"code": "BO",
				"name": "Bolivia",
				"currency": "BOB"
			},
			{
				"code": "BA",
				"name": "Bosnia and Herzegovina",
				"currency": null
			},
			{
				"code": "BW",
				"name": "Botswana",
				"currency": "BWP"
			},
			{
				"code": "BV",
				"name": "Bouvet Island",
				"currency": "NOK"
			},
			{
				"code": "BR",
				"name": "Brazil",
				"currency": "BRL"
			},
			{
				"code": "IO",
				"name": "British Indian Ocean Territory",
				"currency": "USD"
			},
			{
				"code": "BN",
				"name": "Brunei",
				"currency": "BND"
			},
			{
				"code": "BG",
				"name": "Bulgaria",
				"currency": "BGN"
			},
			{
				"code": "BF",
				"name": "Burkina Faso",
				"currency": "XOF"
			},
			{
				"code": "BI",
				"name": "Burundi",
				"currency": "BIF"
			},
			{
				"code": "KH",
				"name": "Cambodia",
				"currency": "KHR"
			},
			{
				"code": "CM",
				"name": "Cameroon",
				"currency": "XAF"
			},
			{
				"code": "CA",
				"name": "Canada",
				"currency": "CAD"
			},
			{
				"code": "CV",
				"name": "Cape Verde",
				"currency": "CVE"
			},
			{
				"code": "KY",
				"name": "Cayman Islands",
				"currency": "KYD"
			},
			{
				"code": "CF",
				"name": "Central African Republic",
				"currency": "XAF"
			},
			{
				"code": "TD",
				"name": "Chad",
				"currency": null
			},
			{
				"code": "CL",
				"name": "Chile",
				"currency": "CLP"
			},
			{
				"code": "CN",
				"name": "China",
				"currency": "CNY"
			},
			{
				"code": "CX",
				"name": "Christmas Island",
				"currency": "AUD"
			},
			{
				"code": "CC",
				"name": "Cocos (Keeling) Islands",
				"currency": "AUD"
			},
			{
				"code": "CO",
				"name": "Colombia",
				"currency": "COP"
			},
			{
				"code": "KM",
				"name": "Comoros",
				"currency": "KMF"
			},
			{
				"code": "CG",
				"name": "Congo",
				"currency": "XAF"
			},
			{
				"code": "CK",
				"name": "Cook Islands",
				"currency": "NZD"
			},
			{
				"code": "CR",
				"name": "Costa Rica",
				"currency": "CRC"
			},
			{
				"code": "HR",
				"name": "Croatia",
				"currency": "EUR"
			},
			{
				"code": "CU",
				"name": "Cuba",
				"currency": "CUP"
			},
			{
				"code": "CY",
				"name": "Cyprus",
				"currency": "EUR"
			},
			{
				"code": "CZ",
				"name": "Czech Republic",
				"currency": "CZK"
			},
			{
				"code": "DK",
				"name": "Denmark",
				"currency": "DKK"
			},
			{
				"code": "DJ",
				"name": "Djibouti",
				"currency": "DJF"
			},
			{
				"code": "DM",
				"name": "Dominica",
				"currency": "XCD"
			},
			{
				"code": "DO",
				"name": "Dominican Republic",
				"currency": "DOP"
			},
			{
				"code": "TP",
				"name": "East Timor",
				"currency": null
			},
			{
				"code": "EC",
				"name": "Ecuador",
				"currency": "USD"
			},
			{
				"code": "EG",
				"name": "Egypt",
				"currency": "EGP"
			},
			{
				"code": "SV",
				"name": "El Salvador",
				"currency": "SVC"
			},
			{
				"code": "GQ",
				"name": "Equatorial Guinea",
				"currency": "XAF"
			},
			{
				"code": "ER",
				"name": "Eritrea",
				"currency": "ERN"
			},
			{
				"code": "EE",
				"name": "Estonia",
				"currency": "EUR"
			},
			{
				"code": "ET",
				"name": "Ethiopia",
				"currency": "ETB"
			},
			{
				"code": "FK",
				"name": "Falkland Islands",
				"currency": null
			},
			{
				"code": "FO",
				"name": "Faroe Islands",
				"currency": "DKK"
			},
			{
				"code": "FJ",
				"name": "Fiji Islands",
				"currency": "FJD"
			},
			{
				"code": "FI",
				"name": "Finland",
				"currency": "EUR"
			},
			{
				"code": "FR",
				"name": "France",
				"currency": "EUR"
			},
			{
				"code": "GF",
				"name": "French Guiana",
				"currency": "EUR"
			},
			{
				"code": "PF",
				"name": "French Polynesia",
				"currency": null
			},
			{
				"code": "TF",
				"name": "French Southern territories",
				"currency": "EUR"
			},
			{
				"code": "GA",
				"name": "Gabon",
				"currency": "XAF"
			},
			{
				"code": "GM",
				"name": "Gambia",
				"currency": "GMD"
			},
			{
				"code": "GE",
				"name": "Georgia",
				"currency": "GEL"
			},
			{
				"code": "DE",
				"name": "Germany",
				"currency": "EUR"
			},
			{
				"code": "GH",
				"name": "Ghana",
				"currency": "GHS"
			},
			{
				"code": "GI",
				"name": "Gibraltar",
				"currency": "GIP"
			},
			{
				"code": "GR",
				"name": "Greece",
				"currency": "EUR"
			},
			{
				"code": "GL",
				"name": "Greenland",
				"currency": "DKK"
			},
			{
				"code": "GD",
				"name": "Grenada",
				"currency": "XCD"
			},
			{
				"code": "GP",
				"name": "Guadeloupe",
				"currency": null
			},
			{
				"code": "GU",
				"name": "Guam",
				"currency": "USD"
			},
			{
				"code": "GT",
				"name": "Guatemala",
				"currency": "QTQ"
			},
			{
				"code": "GN",
				"name": "Guinea",
				"currency": "GNF"
			},
			{
				"code": "GW",
				"name": "Guinea-Bissau",
				"currency": null
			},
			{
				"code": "GY",
				"name": "Guyana",
				"currency": "GYD"
			},
			{
				"code": "HT",
				"name": "Haiti",
				"currency": "HTG"
			},
			{
				"code": "HM",
				"name": "Heard Island and McDonald Islands",
				"currency": "AUD"
			},
			{
				"code": "VA",
				"name": "Holy See (Vatican City State)",
				"currency": null
			},
			{
				"code": "HN",
				"name": "Honduras",
				"currency": "HNL"
			},
			{
				"code": "HK",
				"name": "Hong Kong",
				"currency": "HKD"
			},
			{
				"code": "HU",
				"name": "Hungary",
				"currency": "HUF"
			},
			{
				"code": "IS",
				"name": "Iceland",
				"currency": "ISK"
			},
			{
				"code": "IN",
				"name": "India",
				"currency": "INR"
			},
			{
				"code": "ID",
				"name": "Indonesia",
				"currency": "IDR"
			},
			{
				"code": "IR",
				"name": "Iran",
				"currency": "IRR"
			},
			{
				"code": "IQ",
				"name": "Iraq",
				"currency": "IQD"
			},
			{
				"code": "IE",
				"name": "Ireland",
				"currency": "EUR"
			},
			{
				"code": "IL",
				"name": "Israel",
				"currency": "ILS"
			},
			{
				"code": "IT",
				"name": "Italy",
				"currency": "EUR"
			},
			{
				"code": "CI",
				"name": "Ivory Coast",
				"currency": "XOF"
			},
			{
				"code": "JM",
				"name": "Jamaica",
				"currency": "JMD"
			},
			{
				"code": "JP",
				"name": "Japan",
				"currency": "JPY"
			},
			{
				"code": "JO",
				"name": "Jordan",
				"currency": "JOD"
			},
			{
				"code": "KZ",
				"name": "Kazakhstan",
				"currency": null
			},
			{
				"code": "KE",
				"name": "Kenya",
				"currency": "KES"
			},
			{
				"code": "KI",
				"name": "Kiribati",
				"currency": "AUD"
			},
			{
				"code": "KW",
				"name": "Kuwait",
				"currency": "KWD"
			},
			{
				"code": "KG",
				"name": "Kyrgyzstan",
				"currency": "KGS"
			},
			{
				"code": "LA",
				"name": "Laos",
				"currency": "LAK"
			},
			{
				"code": "LV",
				"name": "Latvia",
				"currency": "LVL"
			},
			{
				"code": "LB",
				"name": "Lebanon",
				"currency": "LBP"
			},
			{
				"code": "LS",
				"name": "Lesotho",
				"currency": "LSL"
			},
			{
				"code": "LR",
				"name": "Liberia",
				"currency": "LRD"
			},
			{
				"code": "LY",
				"name": "Libyan Arab Jamahiriya",
				"currency": null
			},
			{
				"code": "LI",
				"name": "Liechtenstein",
				"currency": "CHF"
			},
			{
				"code": "LT",
				"name": "Lithuania",
				"currency": "LTL"
			},
			{
				"code": "LU",
				"name": "Luxembourg",
				"currency": "EUR"
			},
			{
				"code": "MO",
				"name": "Macao",
				"currency": null
			},
			{
				"code": "MK",
				"name": "North Macedonia",
				"currency": "MKD"
			},
			{
				"code": "MG",
				"name": "Madagascar",
				"currency": "MGF"
			},
			{
				"code": "MW",
				"name": "Malawi",
				"currency": "MWK"
			},
			{
				"code": "MY",
				"name": "Malaysia",
				"currency": "MYR"
			},
			{
				"code": "MV",
				"name": "Maldives",
				"currency": "MVR"
			},
			{
				"code": "ML",
				"name": "Mali",
				"currency": "XOF"
			},
			{
				"code": "MT",
				"name": "Malta",
				"currency": "EUR"
			},
			{
				"code": "MH",
				"name": "Marshall Islands",
				"currency": "USD"
			},
			{
				"code": "MQ",
				"name": "Martinique",
				"currency": null
			},
			{
				"code": "MR",
				"name": "Mauritania",
				"currency": "MRO"
			},
			{
				"code": "MU",
				"name": "Mauritius",
				"currency": "MUR"
			},
			{
				"code": "YT",
				"name": "Mayotte",
				"currency": "EUR"
			},
			{
				"code": "MX",
				"name": "Mexico",
				"currency": "MXN"
			},
			{
				"code": "FM",
				"name": "Micronesia, Federated States of",
				"currency": null
			},
			{
				"code": "MD",
				"name": "Moldova",
				"currency": "MDL"
			},
			{
				"code": "MC",
				"name": "Monaco",
				"currency": "EUR"
			},
			{
				"code": "MN",
				"name": "Mongolia",
				"currency": "MNT"
			},
			{
				"code": "MS",
				"name": "Montserrat",
				"currency": "XCD"
			},
			{
				"code": "MA",
				"name": "Morocco",
				"currency": "MAD"
			},
			{
				"code": "MZ",
				"name": "Mozambique",
				"currency": "MZN"
			},
			{
				"code": "MM",
				"name": "Myanmar",
				"currency": "MMR"
			},
			{
				"code": "NA",
				"name": "Namibia",
				"currency": "NAD"
			},
			{
				"code": "NR",
				"name": "Nauru",
				"currency": "AUD"
			},
			{
				"code": "NP",
				"name": "Nepal",
				"currency": "NPR"
			},
			{
				"code": "NL",
				"name": "Netherlands",
				"currency": "EUR"
			},
			{
				"code": "AN",
				"name": "Netherlands Antilles",
				"currency": "ANG"
			},
			{
				"code": "NC",
				"name": "New Caledonia",
				"currency": "XPF"
			},
			{
				"code": "NZ",
				"name": "New Zealand",
				"currency": "NZD"
			},
			{
				"code": "NI",
				"name": "Nicaragua",
				"currency": "NIO"
			},
			{
				"code": "NE",
				"name": "Niger",
				"currency": "XOF"
			},
			{
				"code": "NG",
				"name": "Nigeria",
				"currency": "NGN"
			},
			{
				"code": "NU",
				"name": "Niue",
				"currency": "NZD"
			},
			{
				"code": "NF",
				"name": "Norfolk Island",
				"currency": "AUD"
			},
			{
				"code": "KP",
				"name": "North Korea",
				"currency": "KPW"
			},
			{
				"code": "MP",
				"name": "Northern Mariana Islands",
				"currency": "USD"
			},
			{
				"code": "NO",
				"name": "Norway",
				"currency": "NOK"
			},
			{
				"code": "OM",
				"name": "Oman",
				"currency": "OMR"
			},
			{
				"code": "PK",
				"name": "Pakistan",
				"currency": "PKR"
			},
			{
				"code": "PW",
				"name": "Palau",
				"currency": "USD"
			},
			{
				"code": "PS",
				"name": "Palestine",
				"currency": null
			},
			{
				"code": "PA",
				"name": "Panama",
				"currency": "PAB"
			},
			{
				"code": "PG",
				"name": "Papua New Guinea",
				"currency": "PGK"
			},
			{
				"code": "PY",
				"name": "Paraguay",
				"currency": "PYG"
			},
			{
				"code": "PE",
				"name": "Peru",
				"currency": "PEN"
			},
			{
				"code": "PH",
				"name": "Philippines",
				"currency": "PHP"
			},
			{
				"code": "PN",
				"name": "Pitcairn",
				"currency": null
			},
			{
				"code": "PL",
				"name": "Poland",
				"currency": "PLN"
			},
			{
				"code": "PT",
				"name": "Portugal",
				"currency": "EUR"
			},
			{
				"code": "PR",
				"name": "Puerto Rico",
				"currency": "USD"
			},
			{
				"code": "QA",
				"name": "Qatar",
				"currency": "QAR"
			},
			{
				"code": "RE",
				"name": "Reunion",
				"currency": null
			},
			{
				"code": "RO",
				"name": "Romania",
				"currency": "RON"
			},
			{
				"code": "RU",
				"name": "Russian Federation",
				"currency": "RUB"
			},
			{
				"code": "RW",
				"name": "Rwanda",
				"currency": "RWF"
			},
			{
				"code": "SH",
				"name": "Saint Helena",
				"currency": "SHP"
			},
			{
				"code": "KN",
				"name": "Saint Kitts and Nevis",
				"currency": null
			},
			{
				"code": "LC",
				"name": "Saint Lucia",
				"currency": "XCD"
			},
			{
				"code": "PM",
				"name": "Saint Pierre and Miquelon",
				"currency": "EUR"
			},
			{
				"code": "VC",
				"name": "Saint Vincent and the Grenadines",
				"currency": "XCD"
			},
			{
				"code": "WS",
				"name": "Samoa",
				"currency": "WST"
			},
			{
				"code": "SM",
				"name": "San Marino",
				"currency": "EUR"
			},
			{
				"code": "ST",
				"name": "Sao Tome and Principe",
				"currency": "STD"
			},
			{
				"code": "SA",
				"name": "Saudi Arabia",
				"currency": "SAR"
			},
			{
				"code": "SN",
				"name": "Senegal",
				"currency": "XOF"
			},
			{
				"code": "SC",
				"name": "Seychelles",
				"currency": "SCR"
			},
			{
				"code": "SL",
				"name": "Sierra Leone",
				"currency": "SLL"
			},
			{
				"code": "SG",
				"name": "Singapore",
				"currency": "SGD"
			},
			{
				"code": "SK",
				"name": "Slovakia",
				"currency": "EUR"
			},
			{
				"code": "SI",
				"name": "Slovenia",
				"currency": "EUR"
			},
			{
				"code": "SB",
				"name": "Solomon Islands",
				"currency": "SBD"
			},
			{
				"code": "SO",
				"name": "Somalia",
				"currency": "SOS"
			},
			{
				"code": "ZA",
				"name": "South Africa",
				"currency": "ZAR"
			},
			{
				"code": "GS",
				"name": "South Georgia and the South Sandwich Islands",
				"currency": "GBP"
			},
			{
				"code": "KR",
				"name": "South Korea",
				"currency": "KRW"
			},
			{
				"code": "SS",
				"name": "South Sudan",
				"currency": "SSP"
			},
			{
				"code": "ES",
				"name": "Spain",
				"currency": "EUR"
			},
			{
				"code": "LK",
				"name": "Sri Lanka",
				"currency": null
			},
			{
				"code": "SD",
				"name": "Sudan",
				"currency": "SDG"
			},
			{
				"code": "SR",
				"name": "Suriname",
				"currency": "SRD"
			},
			{
				"code": "SJ",
				"name": "Svalbard and Jan Mayen",
				"currency": null
			},
			{
				"code": "SZ",
				"name": "Swaziland",
				"currency": "SZL"
			},
			{
				"code": "SE",
				"name": "Sweden",
				"currency": "SEK"
			},
			{
				"code": "CH",
				"name": "Switzerland",
				"currency": "CHF"
			},
			{
				"code": "SY",
				"name": "Syria",
				"currency": "SYP"
			},
			{
				"code": "TJ",
				"name": "Tajikistan",
				"currency": "TJS"
			},
			{
				"code": "TW",
				"name": "Taiwan",
				"currency": "TWD"
			},
			{
				"code": "TZ",
				"name": "Tanzania",
				"currency": "TZS"
			},
			{
				"code": "TH",
				"name": "Thailand",
				"currency": "THB"
			},
			{
				"code": "CD",
				"name": "The Democratic Republic of Congo",
				"currency": null
			},
			{
				"code": "TG",
				"name": "Togo",
				"currency": "XOF"
			},
			{
				"code": "TK",
				"name": "Tokelau",
				"currency": "NZD"
			},
			{
				"code": "TO",
				"name": "Tonga",
				"currency": "TOP"
			},
			{
				"code": "TT",
				"name": "Trinidad and Tobago",
				"currency": "TTD"
			},
			{
				"code": "TN",
				"name": "Tunisia",
				"currency": "TND"
			},
			{
				"code": "TR",
				"name": "Turkey",
				"currency": "TRY"
			},
			{
				"code": "TM",
				"name": "Turkmenistan",
				"currency": "TMT"
			},
			{
				"code": "TC",
				"name": "Turks and Caicos Islands",
				"currency": null
			},
			{
				"code": "TV",
				"name": "Tuvalu",
				"currency": "AUD"
			},
			{
				"code": "UG",
				"name": "Uganda",
				"currency": "UGX"
			},
			{
				"code": "UA",
				"name": "Ukraine",
				"currency": "UAH"
			},
			{
				"code": "AE",
				"name": "United Arab Emirates",
				"currency": "AED"
			},
			{
				"code": "GB",
				"name": "United Kingdom",
				"currency": "GBP"
			},
			{
				"code": "US",
				"name": "United States",
				"currency": "USD"
			},
			{
				"code": "UM",
				"name": "United States Minor Outlying Islands",
				"currency": null
			},
			{
				"code": "UY",
				"name": "Uruguay",
				"currency": "UYU"
			},
			{
				"code": "UZ",
				"name": "Uzbekistan",
				"currency": "UZS"
			},
			{
				"code": "VU",
				"name": "Vanuatu",
				"currency": "VUV"
			},
			{
				"code": "VE",
				"name": "Venezuela",
				"currency": "VEF"
			},
			{
				"code": "VN",
				"name": "Vietnam",
				"currency": "VND"
			},
			{
				"code": "VG",
				"name": "Virgin Islands, British",
				"currency": null
			},
			{
				"code": "VI",
				"name": "Virgin Islands, U.S.",
				"currency": "USD"
			},
			{
				"code": "WF",
				"name": "Wallis and Futuna",
				"currency": null
			},
			{
				"code": "EH",
				"name": "Western Sahara",
				"currency": "MAD"
			},
			{
				"code": "YE",
				"name": "Yemen",
				"currency": "YER"
			},
			{
				"code": "YU",
				"name": "Yugoslavia",
				"currency": null
			},
			{
				"code": "ZM",
				"name": "Zambia",
				"currency": "ZMW"
			},
			{
				"code": "ZW",
				"name": "Zimbabwe",
				"currency": "ZWD"
			}
		];
	}
};

const actions = {};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {};

export default {
	state,
	getters,
	actions,
	mutations
};
